"use client";
import {
  Grid,
  GridContent,
  GridItem,
  GridLoadMore,
} from "@aleksundshantu/aunds-utils-react/primitives/grid";
import { ZitateGridOptionsType } from "@/types/ModuleOptionsType";

import { fetchQuotes } from "../../getData/fetchQuotes";
import { QuoatesCard } from "../../components/QuoatesCard/QuoatesCard";
import buttonStyles from "../../components/Button/Button.module.scss";
import { mockQuote } from "@/ui/mock-data";
import { QuotesElementType } from "../QuoteSliderModule/QuoteSliderModule";
import { useGlobalContext } from "@aleksundshantu/aunds-utils-react/contexts";
import { ZitateGridModuleType } from "./QuotesGrid.server";

type QuoteGridProps = {
  data: ZitateGridModuleType;
  cardHeadlineLevel: number;
  zitateGridOptions: ZitateGridOptionsType;
  initialPosts: QuotesElementType[];
  initialTotalPosts: number;
};

const QuoteGridModuleClient = ({
  data,
  zitateGridOptions,
  cardHeadlineLevel,
  initialPosts,
  initialTotalPosts,
}: QuoteGridProps) => {
  const {
    show_avatar,
    show_rating,
    grid_columns: number_cols,
    posts_per_page,
  } = data.layout;

  const {
    grid_options: { grid_navigation },
  } = zitateGridOptions || {};

  const { locale, getIcon, getLabel } = useGlobalContext();

  return (
    <Grid
      postsPerPage={posts_per_page}
      initialItems={initialPosts}
      initialTotalPosts={initialTotalPosts}
      fetchItems={({ page, postsPerPage, offset }) => {
        return fetchQuotes({
          page,
          postsPerPage,
          offset,
          locale,
          module: data,
        });
      }}
      renderLoading
    >
      {(gridPosts, loading) => {
        return (
          <>
            <GridContent justifyContent="center" gap="2rem">
              {gridPosts.map((element, key) => {
                return (
                  <GridItem
                    itemWidth={{
                      mobile: "100%",
                      tablet: "50%",
                      ...(number_cols === "three-cols" && {
                        desktop: "33.3333333%",
                      }),
                    }}
                    key={key}
                  >
                    <QuoatesCard
                      skeleton={loading}
                      element={
                        loading ? mockQuote : (element as QuotesElementType)
                      }
                      cardType="grid"
                      quotesOptions={zitateGridOptions}
                      showAvatar={show_avatar}
                      showRating={show_rating}
                      headling_level={cardHeadlineLevel}
                      getIcon={getIcon}
                      getLabel={getLabel}
                    />
                  </GridItem>
                );
              })}
            </GridContent>
            <GridLoadMore
              grid_navigation={grid_navigation}
              buttonStyles={buttonStyles}
              iconPosition="left"
            />
          </>
        );
      }}
    </Grid>
  );
};

export default QuoteGridModuleClient;
